module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kj-no_data"
  }, [_c('img', {
    staticClass: "kj-no_data-img",
    attrs: {
      "src": require("./no_people.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "kj-no_data-tips"
  }, [_vm._v("现在还没有人帮你砍价哦，"), _c('br'), _vm._v("快去找小伙伴帮忙吧~")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4710ce46","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/noData/index.vue
// module id = 286
// module chunks = 0